// extracted by mini-css-extract-plugin
export default {"btnWrap":"DownloadFileButton_btnWrap__s9nqa"};